export default {
  pgs: [
    {
      href: "dashboard",
      icon: "dashboard",
      text: "总览",
    }, {
      href: "report",
      icon: "report",
      text: "报告列表",
    }, {
      href: "data_manage",
      icon: "data_manage",
      text: "数据管理",
    }, {
      href: "statistics",
      icon: "statistics",
      text: "统计",
    }, {
      href: "recycle_bin",
      icon: "recycle_bin",
      text: "回收站",
    }
  ],
  pgd: [
    {
      href: "dashboard",
      icon: "dashboard",
      text: "总览",
    }, {
      href: "report",
      icon: "report",
      text: "报告列表",
    }, {
      href: "data_manage",
      icon: "data_manage",
      text: "数据管理",
    }
  ],
  azf: [
    {
      href: "dashboard",
      icon: "dashboard",
      text: "总览",
    }, {
      href: "report",
      icon: "report",
      text: "报告列表",
    }, {
      href: "data_manage",
      icon: "data_manage",
      text: "数据管理",
    }, {
      href: "recycle_bin",
      icon: "recycle_bin",
      text: "回收站",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/api/navData.js